import { render, staticRenderFns } from "./toDo.vue?vue&type=template&id=532332ba&scoped=true&"
import script from "./toDo.vue?vue&type=script&lang=js&"
export * from "./toDo.vue?vue&type=script&lang=js&"
import style0 from "./toDo.vue?vue&type=style&index=0&id=532332ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532332ba",
  null
  
)

export default component.exports